// import Swiper JS
import Swiper, { Autoplay, Pagination } from 'swiper';
// import Swiper styles

(function ($) {

  if($('.testimonials-slider').length > 0) {
    const swiper = new Swiper('.testimonials-slider', {
      autoplay: {
        disableOnInteraction: false,
        pauseOnMouseEnter: true
      },
      centeredSlides: true,
      direction: 'horizontal',
      grabCursor: true,
      loop: true,
      modules: [ Autoplay ],
      slidesPerView: "auto",
    });

    if ($(this).closest('.elementor-widget-container').find('.autoplay').length > 0) {
      let speed = $(this).closest('.elementor-widget-container').find('.autoplay').data('speed');
      swiper.params.autoplay.delay = speed;
    }

    let clicked = false;

    swiper.on('transitionStart', function (e) {
      if(!clicked) {
        $('.testimonials .pages a').removeClass('active');
        $('.testimonials .pages a').eq(swiper.realIndex).addClass('active');
      }
      clicked = false;
    });

    $('.testimonials .pages a').click(function(){
      let eq = $(this).data('id') - 1;
      swiper.slideToLoop(eq);
      return false;
    });
  }

})(jQuery);


// WEBPACK FOOTER //
// ./resources/assets/js/partials/sliders/testimonials-slider.js